module.exports = __webpack_public_path__ + "static/media/square-kitchen@2x.14791236.jpg";